import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unit-economics-3/artifacts/z3ko7m68_Cake_Studio.png";

export function SiteFooter() {
  return (
    <footer className="bg-[#FBFBFD] border-t border-[#E5E5EA] py-8">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="flex flex-col items-center gap-4">
          <img src={LOGO_URL} alt="ROCH Consultation" className="h-14 w-auto" />
          <p className="text-[10px] text-[#1D1D1F]/30 font-medium text-center">
            ROCH Consultation &copy; {new Date().getFullYear()} | This evaluates the business model, not execution quality.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/policies#terms" className="text-[10px] text-[#1D1D1F]/40 hover:text-[#1D1D1F]/60 font-medium">Terms</Link>
            <Link to="/policies#privacy" className="text-[10px] text-[#1D1D1F]/40 hover:text-[#1D1D1F]/60 font-medium">Privacy</Link>
            <Link to="/policies#refunds" className="text-[10px] text-[#1D1D1F]/40 hover:text-[#1D1D1F]/60 font-medium">Refund Policy</Link>
            <Link to="/policies" className="text-[10px] text-[#1D1D1F]/40 hover:text-[#1D1D1F]/60 font-medium">All Policies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
